import { useEffect, useRef } from "react";

export default function EmberCanvas({ count = 70, className = "" }) {
  const ref = useRef(null);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const c = ref.current;
    const ctx = c.getContext("2d");
    let w, h, raf;
    const resize = () => { w = c.width = c.offsetWidth; h = c.height = c.offsetHeight; };
    resize();
    window.addEventListener("resize", resize);
    const colors = ["255,85,0", "255,42,85", "255,160,60", "255,0,127", "255,255,255"];
    const mk = (init) => ({
      x: Math.random() * w, y: init ? Math.random() * h : h + 10, r: Math.random() * 2.2 + 0.4,
      vy: -(Math.random() * 1.1 + 0.3), vx: (Math.random() - 0.5) * 0.5, a: Math.random() * 0.8 + 0.2,
      c: colors[Math.floor(Math.random() * colors.length)], ph: Math.random() * 6.28,
    });
    const ps = Array.from({ length: count }, () => mk(true));
    const tick = () => {
      ctx.clearRect(0, 0, w, h);
      ctx.globalCompositeOperation = "lighter";
      ps.forEach((p, i) => {
        p.x += p.vx + Math.sin(p.ph += 0.02) * 0.3; p.y += p.vy; p.a -= 0.0015;
        if (p.y < -10 || p.a <= 0) ps[i] = mk(false);
        ctx.beginPath(); ctx.fillStyle = `rgba(${p.c},${Math.max(p.a, 0)})`;
        ctx.arc(p.x, p.y, p.r * 1.6, 0, 6.28); ctx.fill();
      });
      raf = requestAnimationFrame(tick);
    };
    tick();
    return () => { cancelAnimationFrame(raf); window.removeEventListener("resize", resize); };
  }, [count]);

  return <canvas ref={ref} className={`absolute inset-0 w-full h-full pointer-events-none ${className}`} aria-hidden="true" />;
}
